import { Address } from "../../../models/utilities/address";
import { JsonProperty } from "../../../models/utilities/json-property";

export class OptimizedStopResponse {

    public sequenceId : number = 0;

    @JsonProperty({ toClass : Address })
    public address : Address = new Address();

    public distance : number = 0;

    public travelTime : string = '';

}

export class CalculateRouteResponse {

    @JsonProperty({ toClass : OptimizedStopResponse, designType: 'array' })
    public stops : OptimizedStopResponse[] = [];
    
}
